import store from "../../store/index";

export const logout = () => {
  $cookies.set("jwt", "", 0);
  store.state.loggedIn = false;
  location.reload();
};
